/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SettingsService } from './settings.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private authKey = this.settings.authKey;

  constructor(
    private http: HttpClient,
    private settings: SettingsService,
  ) {}

  public login(username: string, password: string): Observable<any> {
    let url = this.settings.baseUrl + '/api/identity';

    let data = {
      name: username,
      password,
    };

    return this.http
      .post(url, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .pipe(
        map((response: any) => {
          let auth: any = response.access_token;
          this.setAuth(auth);
          return auth;
        }),
      );
  }

  public restorePassword(email: string): Observable<void> {
    let url = `${this.settings.baseUrl}/api/identity/restorePassword`;

    return this.http.post(
      url,
      { email: email },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    ) as any;
  }

  public changePassword(newPassword: string, token: any): Observable<void> {
    let url = `${this.settings.baseUrl}/api/identity/changePassword`;

    return this.http.post(
      url,
      { newPassword: newPassword, token: token },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    ) as any;
  }

  public setPassword(newPassword: string, token: any): Observable<void> {
    let url = `${this.settings.baseUrl}/api/identity/set-password`;

    return this.http.post(
      url,
      { newPassword: newPassword, token: token },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    ) as any;
  }

  public logout(): boolean {
    this.setAuth(null);
    return false;
  }

  // Persist auth into localStorage or removes it if a NULL argument is given
  public setAuth(token: any): boolean {
    if (token) {
      localStorage.setItem(this.authKey, token);
    } else {
      localStorage.removeItem(this.authKey);
    }
    return true;
  }

  // Returns TRUE if the user is logged in, FALSE otherwise.
  public isLoggedIn(): boolean {
    let helper = new JwtHelperService();
    let token = localStorage.getItem(this.authKey);
    return !helper.isTokenExpired(token ?? '');
  }

  public getAccessToken(): string {
    return localStorage.getItem(this.authKey) || '';
  }
}
